import React from 'react'

const Footer = ({
    contactRef,
    sendEmail
}) => {
    return (
        <div className="relative  text-white h-[100vh] sm:flex "
            style={{ backgroundColor: '#E65445' }}
            ref={contactRef}
            id={`contact`}
        >
            <div className="cursor-pointer text-[#FFFFFF] hover:text-[#E65445] font-['Work_Sans'] font-bold text-[30vw] sm:text-[15vw] mr-auto ml-[5vw]" onClick={sendEmail}>
                <div>Email</div>
                <div>Me</div>
            </div>
            <div className="absolute bottom-0 w-full font-['Work_Sans'] text-[3vh] font-medium sm:text-[2vw] mt-auto pr-[7vw] mr-[7vw] mb-[2vw] content-end">
                <div className="text-right" ><label className="cursor-pointer text-[#FFFFFF] hover:text-[#E65445]" onClick={() => window.open("https://github.com/zaimanza", '_blank')}>GitHub</label></div>
                <div className="text-right" ><label className="cursor-pointer text-[#FFFFFF] hover:text-[#E65445]" onClick={() => window.open("https://www.instagram.com/manza.z")}>Instagram</label></div>
            </div>
        </div>
    )
}

export default Footer